import blogimg1 from "../assets/images/blog-img-1.png";
import blogimg2 from "../assets/images/blog-img-2.png";
import blogimg3 from "../assets/images/blog-img-3.png";
import blogimg4 from "../assets/images/blog-img-4.png";
import blogimg5 from "../assets/images/blog-img-5.png";
import blogimg6 from "../assets/images/blog-img-6.png";

const BlogData = [
    {
        id:1,
        image:blogimg1,
        author:"Caresathome",
        date:"28 May 2026",
        title:"How To Bring Down The HbA1c Level?",
        description:"The choice between a train or bus journey depends on various factors such as the distance of the journey, the time available, the cost, and person ",
        slug:"how-to-bring-down-the-hba1c-level"
    },

    {
        id:2,
        image:blogimg2,
        author:"Caresathome",
        date:"29 May 2026",
        title:"Benefits of Home Nursing",
        description:"The choice between a train or bus journey depends on various factors such as the distance of the journey, the time available, the cost, and person ",
        slug:"benefits-of-home-nursing"
    },

      {
        id:3,
        image:blogimg3,
        author:"Caresathome",
        date:"29 May 2026",
        title:"How Traditional Indian Food Can Help in Controlling Your Diabetes",
        description:"The choice between a train or bus journey depends on various factors such as the distance of the journey, the time available, the cost, and person ",
        slug:"benefits-of-home-nursing"
    },

      {
        id:4,
        image:blogimg4,
        author:"Caresathome",
        date:"29 May 2026",
        title:"5 Ways to Prevent the Third Wave of COVID-19 in India",
        description:"The choice between a train or bus journey depends on various factors such as the distance of the journey, the time available, the cost, and person ",
        slug:"benefits-of-home-nursing"
    },

      {
        id:5,
        image:blogimg5,
        author:"Caresathome",
        date:"29 May 2026",
        title:"What to Eat for Better Health?",
        description:"The choice between a train or bus journey depends on various factors such as the distance of the journey, the time available, the cost, and person ",
        slug:"benefits-of-home-nursing"
    },

      {
        id:6,
        image:blogimg6,
        author:"Caresathome",
        date:"29 May 2026",
        title:"Essential ICU Equipment for Setting Up a Home Critical Care Unit",
        description:"The choice between a train or bus journey depends on various factors such as the distance of the journey, the time available, the cost, and person ",
        slug:"benefits-of-home-nursing"
    }
]

export default BlogData;